import './lib/polyfill-nodelist-foreach'
import './lib/polyfill-console'
import './lib/polyfill-custom-event'
import type {ILocale} from './types'
import type {IConfig} from './module/LiveAgent/types/Config'
import LiveAgent from './module/LiveAgent/components/LiveAgent.svelte'
import {IChannel} from './module/Channels/types/Channel'

declare global {
    var locale: ILocale
    var config: IConfig
    var channel: IChannel
}

const rootElement = document.querySelector('script[data-svelte="LiveAgent"]')
if(rootElement) {
    
    const data = JSON.parse(rootElement.innerHTML)
    globalThis.locale = data.locale
    globalThis.config = data.config
    globalThis.channel = data.channel

    let target = document.createElement(rootElement.getAttribute('data-tag') || 'div')
    rootElement.parentNode.replaceChild(target, rootElement)
    
    new LiveAgent({
        target: target
    })

    // sticky stream

    let body = document.querySelector('body');
    let stream = document.querySelector('.auction-agent-stream');

    const sticky = () => {
        let bcr = stream.getBoundingClientRect()
        let streamPos = bcr.y || bcr.top
        if(streamPos <= 0) {
            body.classList.add('sticky-stream')
        } else {
            body.classList.remove('sticky-stream')
        }
    }

    sticky();
    window.addEventListener('resize', sticky);
    document.addEventListener('scroll', sticky, { passive: true });
}